import { gql } from "@apollo/client";

// Handbook Access Queries
export const GET_ALL_HANDBOOK_ACCESS = gql`
  query GetAllHandbookAccess($includeInactive: Boolean) {
    getAllHandbookAccess(includeInactive: $includeInactive) {
      handbookId
      handbookName
      employees
      updatedAt
    }
  }
`;

export const UPSERT_HANDBOOK_ACCESS = gql`
  mutation UpsertHandbookAccess(
    $handbookId: String!
    $handbookName: String
    $employeesToAdd: [String]
    $employeesToRemove: [String]
    $changedBy: String
    $note: String
  ) {
    upsertHandbookAccess(
      handbookId: $handbookId
      handbookName: $handbookName
      employeesToAdd: $employeesToAdd
      employeesToRemove: $employeesToRemove
      changedBy: $changedBy
      note: $note
    ) {
      handbookId
      employees
      updatedAt
    }
  }
`;

// Handbook Queries
export const GET_ALL_HANDBOOKS = gql`
  query GetAllHandbooks($includeInactive: Boolean) {
    getAllHandbooks(includeInactive: $includeInactive) {
      _id
      name
      description
      status
      createdBy
      createdAt
      updatedAt

      file {
        data
        filename
        mimetype
      }

      attachmentHistory {
        userId
        filename
        mimetype
        action
        updatedAt
      }
    }
  }
`;

export const UPSERT_HANDBOOK = gql`
  mutation UpsertHandbook(
    $id: String
    $name: String!
    $description: String
    $data: String
    $filename: String
    $mimetype: String
    $changedBy: String
  ) {
    upsertHandbook(
      id: $id
      name: $name
      description: $description
      data: $data
      filename: $filename
      mimetype: $mimetype
      changedBy: $changedBy
    ) {
      _id
      name
      description
      file {
        filename
        mimetype
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_HANDBOOKS_FOR_EMPLOYEE = gql`
  query GetHandbooksForEmployee($employeeId: String!) {
    getHandbooksForEmployee(employeeId: $employeeId) {
      _id
      name
      description
      file {
        data
        filename
        mimetype
      }
      attachmentHistory {
        action
        filename
      }
      createdBy
      updatedBy
      createdAt
      updatedAt
      status
    }
  }
`;

export const DELETE_HANDBOOK = gql`
  mutation DeleteHandbook($id: String!, $changedBy: String) {
    deleteHandbook(id: $id, changedBy: $changedBy) {
      _id
      status
      updatedBy
    }
  }
`;